import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions, apiActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { IAppState, TMembershipPolicy } from '../../types/state.d';
import { getTeamGuid } from '../../selectors/apiSelectors';

const updateMembershipPolicy = (membershipPolicy: TMembershipPolicy) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UPDATE_MEMBERSHIP_POLICY;
  try {
    await auth.refreshAccessTokenIfExpired();
    const teamGuid = getTeamGuid(getState());
    dispatch(httpActions.httpRequestMade(resourceName));
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/membershipPolicy`,
      {
        method: 'PUT',
        body: JSON.stringify({
          membershipPolicy,
        }),
        extraHeaders: {
          ...generateAuthHeaders(auth),
        },
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UPDATE_MEMBERSHIP_POLICY);
    }
    dispatch(apiActions.saveMembershipPolicy(membershipPolicy));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
  }
};

export default updateMembershipPolicy;
